<template>
  <section ref="jrTop" class="jr">
    <list-tabs :active-index="activeIndex" :tabs="tabs" @tab-change="onTabChange" />
    <div class="jr__lists">
      <jr-list
        v-show="activeTab === 'related'"
        :jobs="relatedJobs"
        list-type="Related"
        :bidding-id="biddingId"
        :bidding-session="biddingSession"
        :request-id="requestId"
        :tracking-params="trackingParams"
        :session-id="relatedJobSessionId"
        source="job_detail.related_job"
      />
      <jr-list
        v-show="activeTab === 'company'"
        :jobs="companyJobs"
        list-type="Company"
        :bidding-id="biddingId"
        :bidding-session="biddingSession"
        :request-id="requestId"
        :tracking-params="trackingParams"
        :session-id="companySessionId"
        source="job_detail.company_info"
      />
      <loading v-show="canLoadMore" id="trigger" />
    </div>
  </section>
</template>

<script>
import InfinityScrollMixin from '../../../mixins/list/infinityScroll'
import JobRelatedList from '../../list/jobRelatedList'
import ListTabs from '../../list/listTabs'
import LoadingIcon from '../../loader/loadingIcon'

export default {
  components: {
    'jr-list': JobRelatedList,
    'list-tabs': ListTabs,
    loading: LoadingIcon,
  },
  computed: {
    activeTab() {
      return this.tabs[this.activeIndex]
    },
    canLoadMore() {
      let canLoadMoreResult
      switch (this.activeTab) {
        case 'company': {
          canLoadMoreResult = this.companyJobsTotal > this.companyJobs.length
          break
        }
        case 'related': {
          canLoadMoreResult = this.relatedJobsTotal > this.relatedJobsWithoutAdsTotal
          break
        }
        default:
          canLoadMoreResult = false
          break
      }
      return canLoadMoreResult
    },
    tabs() {
      // Only return non-empty lists
      const tabs = []
      if (this.relatedJobs.length) {
        tabs.push('related')
      }
      if (this.companyJobs.length) {
        tabs.push('company')
      }
      return tabs
    },
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
  methods: {
    onLoadMore() {
      this.$emit('related-jobs-loading', this.activeTab)
    },
    onTabChange(tabIndex) {
      if (tabIndex >= 0 && tabIndex < this.tabs.length) {
        this.activeIndex = tabIndex
        this.$refs.jrTop.scrollIntoView({ behavior: 'auto' })
      }
    },
  },
  mixins: [InfinityScrollMixin],
  props: {
    biddingId: {
      default: '',
      type: String,
    },
    biddingSession: {
      default: '',
      type: String,
    },
    companyJobs: {
      default: () => [],
      type: Array,
    },
    companyJobsTotal: {
      required: true,
      type: Number,
    },
    companySessionId: {
      required: true,
      type: String,
    },
    relatedJobs: {
      default: () => [],
      type: Array,
    },
    relatedJobSessionId: {
      required: true,
      type: String,
    },
    relatedJobsTotal: {
      required: true,
      type: Number,
    },
    relatedJobsWithoutAdsTotal: {
      required: true,
      type: Number,
    },
    requestId: {
      default: '',
      type: String,
    },
    /** Formatted tracking params */
    trackingParams: {
      default: () => ({}),
      type: Object,
    },
  },
}
</script>

<style lang="postcss" scoped>
.jr {
  @apply w-full;
}
.list-tabs {
  @apply z-1;
}
.jr__lists {
  @apply relative z-0;
}
</style>
